import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { usePremium } from "../context/PremiumContext";

// After the first-run guided tour finishes, send non-premium users straight to
// the subscription screen (once). Suppressed for premium/legacy users; in-app only.
export default function OnboardingPaywall() {
  const { inApp, isPremium, isLegacy } = usePremium();
  const navigate = useNavigate();
  useEffect(() => {
    const onFinish = () => {
      if (!inApp || isPremium || isLegacy) return;
      try {
        if (localStorage.getItem("cb_onboarding_paywall_seen") === "1") return;
        localStorage.setItem("cb_onboarding_paywall_seen", "1");
      } catch { /* ignore */ }
      navigate("/premium");
    };
    window.addEventListener("cb-tour-finished", onFinish);
    return () => window.removeEventListener("cb-tour-finished", onFinish);
  }, [inApp, isPremium, isLegacy, navigate]);
  return null;
}
